<template lang="jade">
.container
  .nav.navbar.navbar-default(style="min-height: 61px;")
    .container-fluid
      .navbar-header
        a.navbar-brand(href="/")
          img(src="static/images/mini_logo.png")
      .navbar-collapse.collapse(aria-expanded="true")
        ul.nav.navbar-nav
          li
            router-link(:to="'/status-sheets'" exact)
              span.compacto-meio Status das Folhas
          li
            router-link(:to="'/'" exact)
              span.compacto-meio Verificar Folhas
              img(src="static/images/header_verificar.svg", style="width: 20px;")
          li
            a(href="/")
              span.compacto-meio Gerar Folhas
              img(src="static/images/header_folhas.svg", style="width: 20px;")
          li
            a(href="/")
              span.compacto-meio Busca
              img(src="static/images/header_busca.svg", style="width: 20px;")

        ul.nav.navbar-nav.navbar-right
          li
            a(@click="logout")
              span.compacto-meio Sair
              img(src="static/images/header_sair.svg", style="width: 20px;")
</template>

<script>
  import { mapActions } from 'vuex'
  import Cookies from 'js-cookie'

  export default {
    name: 'mainHeader',
    methods: {
      ...mapActions([
        'setAuthorization',
        'setUserInfo'
      ]),
      logout: function () {
        Cookies.remove('Authorization')
        this.setAuthorization(null)
        this.$store.dispatch('userInfo', null)
        window.location = ''
//        this.$router.push('/login')
      }
    }
  }
</script>

<style scoped>
  .router-link-exact-active, router-link-active {
    border-bottom: 2px solid #4cb6d5;
    color: #4cb6d5 !important;
  }
  span {
    font-family: 'Rubik', sans-serif;
  }

  ul, li {
    margin-top: 0px !important;
  }
</style>




// WEBPACK FOOTER //
// MainHeader.vue?0acd9d9c